import request from '@/utils/request'


// 查询动态信息列表
export function listIntegral(query) {
    return request({
        url: '/h5/integral/list',
        method: 'get',
        params: query
    })
}

// 获取积分排行榜
export function getUserIntegralTop() {
    return request({
        url: '/h5/integral/getUserIntegralTop',
        method: 'get',
    })
}


// 查询动态信息详情
export function listIntegralById(id) {
    return request({
        url: '/h5/integral/' + id,
        method: 'get',
    })
}

// 新增动态信息
export function addIntegral(query) {
    return request({
        url: '/h5/integral/addIntegral',
        method: 'post',
        data: query
    })
}
